function trimTrailingSlash(value: string): string {
    return value.replace(/\/+$/, '')
}

export function getConfiguredBackendUrl(): string {
    const backendUrl = import.meta.env.VITE_BACKEND_URL
    if (typeof backendUrl !== 'string') {
        return ''
    }

    const normalized = backendUrl.trim()
    if (!normalized) {
        return ''
    }

    return trimTrailingSlash(normalized)
}

export function getBackendOrigin(): string {
    const configuredBackendUrl = getConfiguredBackendUrl()
    if (configuredBackendUrl) {
        return configuredBackendUrl
    }

    return window.location.origin
}
